/* eslint-disable */
import axios from "axios";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import ReportViewModal from "./ReportViewModal.vue";
import RunKRIModal from "./RunKRIModal.vue";


export default {
  name: "StudySpecificReport",
  components: { VPagination, ReportViewModal, RunKRIModal },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      reportList: [],
      loading: false,
      studyId: "",
      token: "",
      sites: [],
      searchField: {
        site: "",
        riskName: ""
      },

      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      showFilter: false,
      showViewModal: false,
      selectedReport: null,
      showRunKRIModal: false,
      SortProperty: "createdDate",
      SortOrder: 0,
      allRiskNames: [],
    };
  },

  mounted() {
    window.addEventListener("studyIdChanged", async (event) => {

      this.studyId = store.getters.getStudyIs;
      this.token = store.getters.getIdToken;
      this.getReportList();
      this.getsites();
      this.getRisknames();

    });
    this.studyId = store.getters.getStudyIs;
    this.token = store.getters.getIdToken;
    this.getReportList();
    this.getsites();
    this.getRisknames();
  },

  methods: {
    async getReportList() {
      const idtoken = store.getters.getIdToken;
      this.loading = true;

      try {
        let hasSite = !!this.searchField.site;
        const res = await axios.get(
          `${this.baseurl}/forms/rbqm/getscoreinfos`,
          {
            params: {
              StudyId: this.studyId,
              DataScope:"Site",
              Category: "Study specific KRI",
              RecordType:'Risk',
              DataScopeId: hasSite ? this.searchField.site:"",

              RiskIndicator: this.searchField.riskName || undefined,
              ConvertToNumeric: true,

              pageindex: this.currentPage,
              pagesize: this.pageSize,

              SortProperty: this.SortProperty,
              SortOrder: this.SortOrder,
            },
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json"
            }
          }
        );

        const apiData = res.data || {};
        this.reportList = apiData.entities || [];
        this.totalCount = apiData.totalCount || 0;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);

      } catch (error) {
        console.error("Error loading Study Specific Report", error);
        this.reportList = [];
      } finally {
        this.loading = false;
      }
    },
    searchReports() {
      this.currentPage = 1;
      this.getReportList();
    },
    async getsites() {
      await axios
        .get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&getAll=false`, {
          headers: {
            Authorization: "Bearer " + this.token,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.sites = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async viewDetails(item) {
      this.selectedReport = item;
      this.showViewModal = true;
    },
    async closeViewModal() {
      this.showViewModal = false;
      this.selectedReport = null;
    },
    async openRunKRIModal() {
      this.showRunKRIModal = true;
      this.$emit("openRunKRIModal");
    },
    async closeRunKRIModal() {
      this.showRunKRIModal = false;
      this.getReportList();
    },
     sortSelected(property) {
      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0;
      }

      this.currentPage = 1;
      this.getReportList();
    },
    async getRisknames() {
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/rbqm/getriskitem`,
          {
            params: {
              StudyId: this.studyId,
              pageindex: 1,
              pagesize: 8000,
              SortProperty: "createdDate",
              SortOrder: "desc",
              DataScopeId: "",
              DataScope: "Site",
              Category: "Study specific KRI"
            },
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        const apiData = res.data?.data?.entities || [];

        const names = apiData
          .map(item => item.riskIndicator)
          .filter(name => name);

        this.allRiskNames = [...new Set(names)];

      } catch (err) {
        console.log("Error loading risk names", err);
      }
    }




  }
};
